import {
  STICKY_BAR_OVERLAY_TOP_INSET,
  getStickyOverlayMaxHeight,
} from "../components/stickyBar/stickyBarLayout";
import {
  OVERLAY_POPUP_Z_INDEX_FALLBACK,
  OVERLAY_TOOLTIP_Z_INDEX_FALLBACK,
} from "../components/dialogs/overlayPopupLayer";

const OVERLAY_EDGE_GUTTER = "16px";
const DIALOG_VERTICAL_GUTTER = "64px";
const OVERLAY_POPUP_Z_INDEX = `var(--ll-overlay-popup-z-index, ${OVERLAY_POPUP_Z_INDEX_FALLBACK})`;
const OVERLAY_TOOLTIP_Z_INDEX = `var(--ll-overlay-tooltip-z-index, ${OVERLAY_TOOLTIP_Z_INDEX_FALLBACK})`;

export const createStickyBarMuiOverrides = () => {
  const overlayHeight = getStickyOverlayMaxHeight();
  const overlaySafeMaxHeight = getStickyOverlayMaxHeight({
    subtract: OVERLAY_EDGE_GUTTER,
  });

  return {
    MuiDrawer: {
      styleOverrides: {
        paperAnchorLeft: {
          top: STICKY_BAR_OVERLAY_TOP_INSET,
          height: overlayHeight,
          maxHeight: overlayHeight,
        },
        paperAnchorRight: {
          top: STICKY_BAR_OVERLAY_TOP_INSET,
          height: overlayHeight,
          maxHeight: overlayHeight,
        },
        paperAnchorTop: {
          top: STICKY_BAR_OVERLAY_TOP_INSET,
          maxHeight: overlayHeight,
        },
        paperAnchorBottom: {
          maxHeight: overlayHeight,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        container: {
          marginTop: STICKY_BAR_OVERLAY_TOP_INSET,
          height: overlayHeight,
        },
        paper: {
          maxHeight: getStickyOverlayMaxHeight({
            subtract: DIALOG_VERTICAL_GUTTER,
          }),
        },
        paperFullScreen: {
          maxHeight: "none",
        },
      },
    },
    MuiDatePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiTimePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiDateTimePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiMobileDatePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiMobileTimePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiMobileDateTimePicker: {
      defaultProps: {
        slotProps: {
          dialog: {
            style: { zIndex: OVERLAY_POPUP_Z_INDEX },
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
        paper: {
          maxHeight: overlaySafeMaxHeight,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
        paper: {
          maxHeight: overlaySafeMaxHeight,
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
      },
    },
    MuiSnackbar: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
      },
    },
    MuiPickersPopper: {
      styleOverrides: {
        root: {
          zIndex: OVERLAY_POPUP_Z_INDEX,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        popper: {
          zIndex: OVERLAY_TOOLTIP_Z_INDEX,
        },
      },
    },
  };
};
